define([
    'text!download/component/main.html',
    'common/utils',
    'WebCommon/component/image-link-slick',
    'common/api',
    'download/common/api',
    'lodash',
    'jquery',
    'common/mixin/route',
    'WebCommon/modal/modal'

], function(
    tpl,
    Utils,
    ImageLinkSlick,
    Api,
    Newapi,
    _,
    $,
    RouteMixin,Modal
){
    return {
        template: tpl,
        components: {
            ImageLinkSlick: ImageLinkSlick,
        },
        mixins: [RouteMixin],
        data: function(){
            return {
                slides: [],
                categories: [],
                productType: 1,
                furList: [],
                tableData: [],
                typeList: [
                    {name: '全部',tab: '',link: '/furniture?tab=all'},
                    {name: '椅',tab: '#chair',link: '/furniture?tab=all#chair'},
                    {name: '桌',tab: '#desk',link: '/furniture?tab=all#desk'},
                    {name: '床',tab: '#bed',link: '/furniture?tab=all#bed'},
                    {name: '几',tab: '#lowtable',link: '/furniture?tab=all#lowtable'},
                    {name: '柜',tab: '#cab',link: '/furniture?tab=all#cab'},
                    {name: '沙发',tab: '#sofa',link: '/furniture?tab=all#sofa'},
                    {name: '一枚板',tab: '#ymb',link: '/furniture?tab=all#ymb'},
                    {name: '其他',tab: '#other',link: '/furniture?tab=all#other'}
                ],
                newTypeList: [
                    {name: '新品',tab: 'recommend',link: '/furniture-l2?bom=recommend'},
                    {name: '大地线',link: '/furniture-l2?bom=base'},
                    {name: '山脊线',link: '/furniture-l2?bom=high'},
                    {name: 'FF线',link: '/furniture-l2?bom=ff'},
                    // {name: '回顾',link: '/furniture-l2?bom=ff'},
                ],
                furTab: '',
                isZh: true,
                proWidth: 0,
                innerWidth: 0,
                mouseIn: -1
            };
        },
        computed: {

        },
        watch: {
            categories: 'onRouteChange',
            '$i18n.locale': function () {
                // this.init();
                this.locale();
            }
        },
        methods: {
            toCatalog: function() {
                window.location.href = '/catalog';
            },
            todownloadFile: function(id) {
                var _this = this;
                var memberId = localStorage.getItem('fnjinew_memberId');
                if(memberId){
                    Newapi.checkHasRightApi.ajax({memberId: memberId})
                        .done(function (data) {
                            if(data){
                                _this.downloadFile(id);
                            }else {
                                window.location.href = '/loginnew';
                            }
                        })
                }else {
                    window.location.href = '/loginnew';
                }
            },
            downloadFile: function(id) {
                Newapi.getZipPathApi.ajax({id: id})
                // return Newapi.getDownloadListApi.ajax({category: _this.furTab})
                    .done(function(data){
                        // console.log(data);
                        var url = 'https://website.fnji.com/app-temp/temp/download/'+data;//fnjiportal/u17xwaoyt6j.pdf
                        var xhr = new XMLHttpRequest();
                        xhr.open('GET', url, true);
                        xhr.responseType = 'blob';

                        xhr.onload = function() {
                            if (xhr.status === 200) {
                                var blob = xhr.response;
                                var a = document.createElement('a');
                                var url = URL.createObjectURL(blob);
                                a.href = url;
                                a.download = 'file.zip';
                                a.click();
                                URL.revokeObjectURL(url);
                            }
                        };

                        xhr.send();
                    });
            },
            changeType: function(type){
                var _this = this;
                _this.furTab = type;
                _this.initCategories();
            },
            initCategories: function(){
                var _this = this;
                return Newapi.getDownloadListApi.ajax({category: _this.furTab,lang:this.$i18n.locale})
                // return Newapi.getDownloadListApi.ajax({category: _this.furTab})
                    .done(function(data){
                        // console.log(data);
                        _this.tableData = data;
                        _this.$set(_this.tableData,_this.tableData);
                    });
            },
            onClickSH:function() {
                var _this = this;

                $("body").on("click", ".m-link-slick .slick-slide", function (e) {

                    if(_this.slides[$(this).index()]['description'] != '上海预约')
                        return;
                    e.preventDefault();
                    e.stopPropagation();
                    Modal.showFnjiWeixinSrvModal();
                });
            },
            locale: function(){
                var _this = this;
                _this.proWidth = window.innerWidth*0.9/4;
                _this.innerWidth = window.innerWidth;
                if(_this.$i18n.locale=='en'){
                    _this.isZh = false;
                    // _this.typeList = _this.$i18n.messages.en.typeList;
                    // _this.newTypeList = _this.$i18n.messages.en.newTypeList;
                }else {
                    _this.isZh = true;
                    // _this.typeList = _this.$i18n.messages.zh.typeList;
                    // _this.newTypeList = _this.$i18n.messages.zh.newTypeList;
                }
            },
            init: function(){
                var _this = this;
                Newapi.getFurnitureApi.ajax({lang:this.$i18n.locale})
                    .done(function(data){
                        _this.furList = data;
                        if(_this.furList.length){
                            _this.furTab = _this.furList[0].value;
                        }
                        _this.initCategories();
                    });
            },
            onRouteChange: function(){
                if (!this.categories.length) return;
                if (_.isEmpty(this.catGroup)){
                    this.replaceTabRoute(this.categories[1].type);
                    return;
                }
                this.$nextTick(function(){
                    this.scrollToPos();
                    this.hasInit = true;
                });
            },
            genFurnitureDetailLink: Utils.genFurnitureDetailLink,
            getSkuBgColor: function(sku){
                return sku.bgColor ? sku.bgColor.value : '';
            },
            genFurnitureL2Link: Utils.genFurnitureL2Link
        },
        mounted: function(){
            this.init();
            this.locale();
        },
        filters: {
            descName: function(str){
                return (str||'').split(/\s*<br>\s*/)[0];
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./download/component/main.js
// module id = 350
// module chunks = 8